/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { loadingElement } from "./utils/loadingElement";
import { handleFormData } from "./form";

/**
 * @param form
 * @param action
 * @param type
 * @property {string} editPageRoute
 */
function savePageForm(form, action, type) {
  if (action === void 0) {
    action = 'edit';
  }
  if (type === void 0) {
    type = 'page';
  }
  var route = form.action;
  if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
  var editPageRoute = form.dataset.editPageRoute;
  if (!editPageRoute) return console.warn(adminConfig.messages.routeNotSpecified);
  var formDataArray = handleFormData(form);
  var queryString = new URLSearchParams(formDataArray).toString();
  if (adminConfig.forms['entire-page-form'].validate()) {
    loadingElement.start(form);
    httpRequest({
      url: route,
      data: queryString
    }).then(function (response) {
      if (response && response.data) {
        var _response$data$type;
        if (response.data.success && action === 'create' && (_response$data$type = response.data[type]) != null && _response$data$type.id) {
          window.location.href = editPageRoute.replace('[' + type + 'Id]', response.data[type].id);
        }
      }
    })["finally"](function () {
      loadingElement.finish(form);
    });
  }
}

/**
 * @property {string} relatedTabBtn
 */
export function savePageFormInit() {
  var savePostPageBtnElements = document.querySelectorAll('.save-page-form-btn');
  var savePostPageForm = document.getElementById('entire-page-form');
  if (savePostPageForm && savePostPageBtnElements.length > 0) {
    for (var i = 0; i < savePostPageBtnElements.length; i++) {
      savePostPageBtnElements[i].addEventListener("click", function (e) {
        e.preventDefault();
        var /**@type HTMLElement*/button = e.target;
        var action = button.dataset.action ? button.dataset.action : 'edit';
        var type = button.dataset.type ? button.dataset.type : 'page';
        savePageForm(savePostPageForm, action, type);
      });
    }
    var statusSelect = savePostPageForm.querySelector('.status-select');
    statusSelect == null ? void 0 : statusSelect.addEventListener("change", function (e) {
      e.preventDefault();
      var currentValue = e.target.value;
      var publishDateContainer = document.querySelector('.publish-date-container');
      console.warn(currentValue);
      if (currentValue === 'Future') {
        publishDateContainer.classList.remove('d-none');
      } else {
        publishDateContainer.classList.add('d-none');
      }
    });
  }
}